import WarningIcon from "@mui/icons-material/Warning";
import FeedbackDialog from "./FeedbackDialog.js";

export default function ErrorDialog({ locales, message, onClose, show }) {
  return (
    <FeedbackDialog
      bodyPrimary={locales["error.body1"]}
      bodySecondary={message || locales["error.body2"]}
      icon={WarningIcon}
      iconColor="error"
      locales={locales}
      onClose={onClose}
      show={show}
      title={locales["error.title"]}
    />
  );
}
